/**
 * Dev-login access mode (mirrors backend src/utils/devLogin.ts).
 *
 * `devLoginEnabled` — whether dev login exists in this build at all
 * (VITE_ENABLE_DEV_LOGIN). On locally + staging; off in production.
 *
 * `devLoginRequiresAdmin` — whether dev login is the post-auth ADMIN-only tool
 * (link hidden on Sign-In, /dev/login gated to admins) vs. the open pre-auth
 * picker. An explicit VITE_DEV_LOGIN_REQUIRE_ADMIN override wins; otherwise the
 * secure default is "require admin in every built bundle (staging/prod), open
 * only on the Vite dev server" (import.meta.env.DEV).
 */
export const devLoginEnabled = import.meta.env.VITE_ENABLE_DEV_LOGIN === 'true';

export const devLoginRequiresAdmin: boolean = (() => {
  const flag = import.meta.env.VITE_DEV_LOGIN_REQUIRE_ADMIN;
  if (flag === 'true') return true;
  if (flag === 'false') return false;
  return !import.meta.env.DEV;
})();
